var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88552 4.2L2.32031 4.2M9.88552 4.2L9.38466 10.1638C9.32549 10.7797 8.80372 11.25 8.17967 11.25L4.02615 11.25C3.40211 11.25 2.88034 10.7797 2.82117 10.1638L2.32031 4.2M9.88552 4.2C10.2198 4.2 10.4907 3.93137 10.4907 3.6L10.4907 2.4C10.4907 2.06863 10.2198 1.8 9.88552 1.8L2.32031 1.8C1.98605 1.8 1.71509 2.06863 1.71509 2.4L1.71509 3.6C1.71509 3.93137 1.98605 4.2 2.32031 4.2M4.89248 9.375L4.89248 6.9M4.74117 0.75L7.46465 0.75M7.46465 9.375L7.46465 6.9",
    stroke: "#C4330F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.b75409a32e13bda79f462e915dc7c713.svg";
export { ForwardRef as ReactComponent };